var exports = {
  "z": "xa15a2ab7--2a8789--text-row",
  "U": "xa15a2ab7--2a8789--buttons",
};

module.exports = exports;
